import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";
import sampleImage from "../../../Image/faq.jpg";

const newsData = [
  {
    title: "What programming languages are most important for a career in Machine Learning?",
    
    description:
      "Python is the most important language for Machine Learning due to libraries like Scikit-Learn, NumPy, Pandas, TensorFlow, and PyTorch. SQL is essential for data handling. While R, Java, and C++ appear in specific cases, Python + SQL remains the industry standard.",
  },
  {
    title: "What job roles are available in the Machine Learning field?",
  
    description:
      "Machine Learning offers roles like ML Engineer, Data Scientist, ML Researcher, MLOps Engineer, AI Engineer, and Predictive Modeling Analyst. Each role focuses on tasks such as building models, optimizing algorithms, validating performance, and deploying solutions in real-world environments.",
  },
  {
    title: "What tools and technologies are commonly used in Machine Learning?",
    
    description:
      "Machine Learning uses tools like Scikit-Learn, TensorFlow, PyTorch, Keras, Pandas, NumPy, Matplotlib, and Jupyter Notebook for preprocessing, training, and evaluation. Engineers also use GitHub, Docker, and MLflow for version control, deployment, and experiment tracking.",
  },
  {
    title: "What educational background is required to start learning Machine Learning?",
    
    description:
      "You don’t need a specific degree to learn Machine Learning. Students from IT, engineering, math, statistics, or business can start. Basic math and logical thinking help, but beginners can learn ML easily with proper guidance and practice.",
  },
  {
    title: "How does Machine Learning differ from traditional programming?",
    
    description:
      "Traditional programming uses fixed, rule-based instructions written by developers, producing predictable outputs. Machine Learning learns patterns from data, improves automatically, and handles complex tasks like prediction and classification that are difficult to code manually with traditional logic.",
  },
];

const FAQ = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleDescription = (i) => {
    setExpandedIndex(expandedIndex === i ? null : i);
  };

  return (
    <div className="faq-wrapper">
      <motion.h2
        className="faq-heading"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        FAQ — Frequently Asked Questions
      </motion.h2>
      <div className="news-section-container">
        <motion.div
          className="news-left-image"
          initial={{ opacity: 0, rotateY: -90 }}
          whileInView={{ opacity: 1, rotateY: 0 }}
          transition={{
            duration: 0.9,
            ease: "easeOut",
            delay: 0.2,
          }}
          viewport={{ once: false, amount: 0.4 }}
        >
          <img src={sampleImage} alt="Main Preview" />
        </motion.div>

        <motion.div
          className="news-right-list"
          initial={{ opacity: 0, scale: 0.8, y: 40 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          transition={{
            duration: 0.8,
            ease: "easeOut",
            delay: 0.3,
          }}
          viewport={{ once: false, amount: 0.3 }}
        >
          {newsData.map((item, index) => (
            <motion.div
              key={index}
              className="news-item"
              whileHover={{ x: 10, backgroundColor: "#eefef6" }}
              transition={{ duration: 0.3 }}
              onClick={() => toggleDescription(index)}
            >
              <div className="row">
                <div className="title">{item.title}</div>

                <div className="category">{item.category}</div>

                <motion.div
                  animate={{ rotate: expandedIndex === index ? 90 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="arrow"
                >
                  ➤
                </motion.div>
              </div>

              <AnimatePresence>
                {expandedIndex === index && (
                  <motion.div
                    className="card-description"
                    layout
                    initial={{ opacity: 0, maxHeight: 0 }}
                    animate={{ opacity: 1, maxHeight: 800 }}
                    exit={{ opacity: 0, maxHeight: 0 }}
                    transition={{
                      duration: 0.45,
                      ease: "easeInOut",
                    }}
                  >
                    {item.description}
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default FAQ;
